<template>
  <div>
    <div class="row">

    <div class="col-sm-12 col-md-12 breadcrumb-side-button">
    </div>
      <div class="float-md-right mb-3">

        <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('print_detail')">
          <button
              type="button"
              @click.prevent="generateReport"
              class="btn btn-primary btn-sm">Print
          </button>
        </el-tooltip>

      </div>
    </div>
    <div class="row">

      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <div class="card card-with-shadow border-0 h-100">
          <app-overlay-loader v-if="preloader"/>
          <div class="card-header d-flex justify-content-between align-items-center p-primary bg-transparent">
            <a href="#" v-on:click="showCheckForm(1)"> <h5 class="card-title d-inline-block mb-0">{{$t('check-in')}}</h5>
            </a>
          </div>
          <div class="card-body">
            <check-in-form v-if="CheckForm" :siteLogUrl="siteLogUrl"  siteCheckingType="checkIn" buttonText="Checkin" eventType="1"/>
          </div>

        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <div class="card card-with-shadow border-0 h-100">
          <app-overlay-loader v-if="preloader"/>
          <div class="card-header d-flex justify-content-between align-items-center p-primary bg-transparent">
            <a href="#" v-on:click="showCheckForm(2)">
              <h5 class="card-title d-inline-block mb-0">{{$t('check-out')}}</h5>
            </a>

          </div>
          <div class="card-body">
            <check-in-form  v-if="checkOutForm" :siteLogUrl="siteLogUrl" siteCheckingType="checkOut" buttonText="Checkout" eventType="2"/>
          </div>

        </div>
      </div>


    </div>

  </div>
</template>


<script>

import {TableHelpers} from "../../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import {
  SITE_LOGS,
  SITE_LOGS_LIST, SITE_LOGS_DATA
} from "../../../../../../Config/ApiUrl.js";
import {axiosGet} from "../../../../../../Helpers/AxiosHelper.js";
import {FormMixin} from "@/core/mixins/form/FormMixin";

import GlobalHelperMixin from "@/app/Mixins/global/GlobalHelperMixin";
import AppLibrary from "@/app/Helpers/AppLibrary";

export default {
  extends: CoreLibrary,
  mixins: [GlobalHelperMixin, FormMixin, AppLibrary, TableHelpers],
  props:{
    siteId: Number,
  },
  data() {
    return {
      checkOutForm: false,
      CheckForm: false,
      instructionShow: false,
      showCheckInCalendar: false,
      bgStyle: true,
      isTaskReminderModalActive: false,
      classRemove: true,
      displayForm: false,
      preloader: false,
      idsToValues: {},
      eventTypes: {},
      eventStatus: {},
      severity: {},
      siteData:{},
      siteLogUrl: SITE_LOGS + '/' + this.$attrs['props'].siteId,
      inputs: {},
      iconClass: 'plus-circle',
      active: 1,
      task_id: 0,
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: SITE_LOGS_LIST + '/' + this.$attrs['props'].siteId,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("event_type"),
            type: "custom-html",
            key: "event_type",
            modifier: (value) => {
              return `<span>${value}</span>`;
            }
          },
          {
            title: this.$t("severity"),
            type: "custom-html",
            key: "severity",
            modifier: (value) => {
              return `<span>${value}</span>`;
            }
          },

          {
            title: this.$t("event_detail"),
            type: "custom-html",
            key: "event_detail",
            modifier: (value) => {
              return `<span>${value}</span>`;
            },
          },
          {
            title: this.$t("event_recorded_at"),
            type: "custom-html",
            key: "event_recorded_at",
            modifier: (value) => {
              let event_time = moment(value, ["h:mm"]).format("d/m/y h:mm A");
              return `<span>${this.$t(event_time)}</span>`;
            },
          },

          {
            title: this.$t("event_status"),
            type: "custom-html",
            key: "event_status",
            modifier: (value) => {
              return `<span>${value}</span>`;
            }
          }

        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
        ],
        filters: [
          {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 5,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {

    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    themeMode() {
      return this.$store.state.theme;
    },
  },
  methods: {
    showCheckForm(eventType){
      if (eventType === 1) this.CheckForm = true
      if (eventType === 2) this.checkOutForm = true
    },
    showDateTime(condition) {
      this.showCheckInCalendar = condition
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
    },

    beforeSubmit() {
      this.preloader = true;
    },
    submit(event_type) {
      this.inputs.event_type = event_type;
      this.save(this.inputs);

    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {};
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
    },
    getListValues() {

      axiosGet(SITE_LOGS_DATA + "/" + this.siteId).then((response) => {
        this.idsToValues = response.data.ids_to_values;
        this.eventStatus = response.data.event_status;
        this.severity = response.data.severity;
        this.eventTypes = response.data.event_types;
      });
    },

    searchAndSelectFilterOptions() {
      // axiosGet(GET_SITE_USER_ASSIGNED_LIST + "/" + this.siteId).then((response) => {
      //
      //
      //   name.option = response.data.map((name) => {
      //     return {
      //       id: name.id,
      //       value: name.value,
      //     };
      //   });
      // });
    },
  },
  mounted() {
    this.$hub.$on('siteData', (data) => {
      this.siteData = data;
    })
    this.getListValues();
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");

  },
};
</script>
